<template lang="pug">
.appVerComponent.fz07rem.fwm.tar.usn

  //- BloqueoOrientacion(style="z-index: 11;")
  .px1ud.aic.posr.gap1rem(style="z-index: 10;")
    ClientOnly
      .aic.gap02rem(v-if="contextoApp.buildConfig.modo !== 'produccion'") 
        .posf.l0.r0.atencionFondo.h1em.z-1(v-if="staging" style="mask-image: linear-gradient(to left, rgba(0,0,0,.4) 10em, black 20em)")
        .aic.gap03rem
          div {{ hora }} 
          .op05 {{ timezoneCliente }} 
          .op03 {{ reloj.format('Z') }}

          
    .aic.posr.gap03rem
      .op1(v-if="contextoApp.buildConfig.modo !== 'produccion'")  {{contextoApp.appConfig.appID}}
      .op1 v{{ contextoApp.buildConfig.version }}
      .op05(v-if="contextoApp.buildConfig.modo !== 'produccion'")  {{contextoApp.buildConfig.modo}}
      .op1(v-if="extra") {{extra}}
  //- .px1ud
    slot
</template>

<script lang="ts" setup>
defineProps<{
  extra?: string
}>()

const staging = contextoApp.buildConfig.adminUrl.startsWith('https://staging')

const hora = computed(() => unref(reloj).format('HH:mm'))
</script>

<style lang="sass" scoped>
@use '@base/sass/comun'
.appVerComponent
  line-height: 1
  padding-top: 0.25rem
  padding-right: 0.5rem
  z-index: 1000
  +comun.movil
    padding-top: 0.1rem
    padding-right: 0.25rem
</style>
